import { Component, Input } from '@angular/core';
@Component({
  selector: 'amp-loading',
  templateUrl: './amp-loading.component.html',
  styleUrls: ['./amp-loading.component.scss']
})
export class AmpLoadingComponent {
  @Input() size: number = 70;
}
